import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { Breadcrumb } from './interface/breadcrumb.interface';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [CommonModule, RouterModule, CoreModule],
})
export class BreadcrumbComponent implements AfterViewInit {
  breadcrumbs: Breadcrumb[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    this.cdr.detectChanges();
  }

  createBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const breadcrumbLabel = child.snapshot.data['breadcrumb'];
      if (breadcrumbLabel) {
        // Handle both string and array breadcrumb formats
        const labels = Array.isArray(breadcrumbLabel) ? breadcrumbLabel : [breadcrumbLabel];

        for (const label of labels) {
          if (breadcrumbs.length > 0 && breadcrumbs[breadcrumbs.length - 1].label === label) {
            breadcrumbs[breadcrumbs.length - 1].url = url;
          } else {
            breadcrumbs.push({ label, url });
          }
        }
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
